// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"102":"4b631576","126":"eabee5a9","128":"d55e349f","174":"db21b803","468":"161b9abf","504":"b213005a","742":"19d4cc4f"}[chunkId] + ".js";
};